import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class OneButton extends Component {

  _CLASS_NAME = '.mini-player:not(.is-disabled)';

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {

    $(document).on('click', this._CLASS_NAME, (event) => {
      return this.onClick(event);
    });

    this.App.Events.subscribe('player.audio.playing', (event) => {
      return this.onPlay(event);
    });
    this.App.Events.subscribe('player.audio.pause',   (event) => {
      return this.onStop(event);
    });
    this.App.Events.subscribe('player.audio.stop',    (event) => {
      return this.onStop(event);
    });
    this.App.Events.subscribe('player.audio.ended',   (event) => {
      return this.onStop(event);
    });
  }

  onClick(event) {
    let element = $(event.currentTarget),
        src = element.data('src'),
        title = element.data('title');

    if (element.hasClass('is-playing')) {
      this.App.Player.Engine.pause();
    } else {
      this.setAsLoading(element);
      this.App.Player.Engine.play(src, title);
    }

    event.preventDefault();
  }

  stopAllExcept(src) {
    $(`.is-playing:not([data-src="${src}"])`).each(function () {
      let element = $(this);
      element.removeClass('is-playing');
    });
  }

  setAsLoading(element) {
    if (!element.hasClass('is-playing')) {
      element.addClass('is-loading');
    }
  }

  findPlayerElement(src) {
    return $(`[data-src="${src}"]`);
  }

  onPlay(data) {
    let element = this.findPlayerElement(data.media.currentSrc);
    if (!element) return false;
    this.stopAllExcept(data.media.currentSrc);
    element.removeClass('is-loading').addClass('is-playing');
  }

  onStop(data) {
    let element = this.findPlayerElement(data.media.currentSrc);
    if (!element) return false;
    element.removeClass('is-loading is-playing');
  }

}